export default __webpack_public_path__ + "static/accents-role-dont-e30c93720296d27403b22cbf1381a5d1.png";